import { isProd } from "constants/urls";
import { useMemo } from "react";
import useUsuario from "./useUsuario";

const useAlbert = () => {
  const albert = useMemo(() => {
    window.dataLayer = window.dataLayer || [];
    return window.dataLayer;
  }, []);

  const AUTO_EVENTS = useMemo(
    () => ({
      albert_get_quote: "albert_get_quote",
      albert_choose_plan: "albert_choose_plan",
      albert_payment_info: "albert_payment_info",
      albert_purchase: "albert_purchase",
    }),
    []
  );
  const AUTO_OPERATIONS = useMemo(
    () => ({
      albert_dtc_auto: "albert_dtc_auto",
    }),
    []
  );
  const { isDTC } = useUsuario();
  /**
   * @param {string} op_id
   * @param {string} eventId
   * @param {{
   *    albert_transaction_id:string,
   *    albert_value:number|string
   * }} payload
   */
  const addAutoEvent = (op_id, eventId, payload = {}) => {
    const IS_PROD = isProd();

    if (IS_PROD && isDTC) {
      albert.push({
        event: eventId,
        albert_op_id: op_id,
        ...payload,
      });
    }
    console.log(`ALBERT EVENT: ${op_id} ${eventId}`, payload);
  };

  /**
   * @param {string} eventId
   * @param {Record<string,any>} payload
   */
  const addApEvent = (eventId, payload = {}) => {
    if (isDTC) {
      albert.push({
        event: eventId,
        albert_op_id: "albert_accident",
        ...payload,
      });
    }
  };

  return { albert, addAutoEvent, AUTO_EVENTS, AUTO_OPERATIONS, addApEvent };
};

export default useAlbert;
